import React, { Component } from 'react';
import PropTypes from 'prop-types';

import List from './List';
import Pager from './Pager';
import Filters from './Filters';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    // const items = drupalSettings.dashboardData;
    const { items } = this.props;

    // Get list of institutions and sectors.
    const institutions = [];
    const sectors = [];

    items.forEach((element) => {
      // Institutions.
      if (institutions.indexOf(element.tags[0]) === -1) {
        institutions.push(element.tags[0]);
      }
      // Sectors.
      if (element.tags[1] !== null && element.tags[1] !== undefined) {
        const elementSectors = element.tags[1].split(';').map(sector => sector.trim());
        elementSectors.forEach((sector) => {
          if (sectors.indexOf(sector) === -1) {
            sectors.push(sector);
          }
        });
      }
    });

    // Sort arrays.
    institutions.sort();
    sectors.sort();

    let currentPage = null;
    if (window.URLSearchParams) {
      const searchParams = new URLSearchParams(window.location.search);
      currentPage = searchParams.get('pagina');
    }

    this.state = {
      visibleItems: items,
      institutions,
      sectors,
      pageOffset: currentPage ? currentPage - 1 : 0,
    };

    this.goToPage = this.goToPage.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
  }

  goToPage(page) {
    this.setState({
      pageOffset: page - 1,
    });
    if (window.URLSearchParams) {
      const searchParams = new URLSearchParams(window.location.search);
      if (page === 1) {
        searchParams.delete('pagina');
      } else {
        searchParams.set('pagina', page);
      }
      let searchString = searchParams.toString();
      searchString = searchString ? `?${searchString}` : '';
      window.history.pushState(null, null, `${window.location.pathname}${searchString}`);
    }
    // Scroll to top of element.
    const element = document.getElementById('react-app');
    const elementTop = element.getBoundingClientRect().top;
    window.scrollTo({
      left: 0,
      top: elementTop + window.pageYOffset,
      behavior: 'smooth',
    });
  }

  applyFilters(text, institutions, sectors) {
    const { items, fulltextFilter } = this.props;
    let visibleItems = items;
    // Filter by text.
    if (text) {
      visibleItems = fulltextFilter(visibleItems, text);
    }
    // Filter by sectors.
    if (sectors && sectors.indexOf('Todos') === -1) {
      visibleItems = visibleItems.filter((element) => {
        let found = false;
        sectors.forEach((sector) => {
          // Avoid null data in field.
          var searchTarget = '';
          const tag1 = element.tags[1];
          if (tag1 != null) {
            searchTarget = tag1.toLowerCase();
          }

          if (searchTarget.indexOf(sector.toLowerCase()) !== -1) {
            found = true;
          }
        });
        return found;
      });
    }

    // Filter by institutions.
    if (institutions && institutions.indexOf('Todos') === -1) {
      visibleItems = visibleItems.filter((element) => {
        let found = false;
        institutions.forEach((inst) => {
          // Avoid null data in field.
          var searchTarget = '';
          const tag0 = element.tags[0];
          if (tag0 != null) {
            searchTarget = tag0.toLowerCase();
          }

          if (searchTarget === inst.toLowerCase()) {
            found = true;
          }
        });
        return found;
      });
    }
    this.setState({
      visibleItems,
      pageOffset: 0,
    });
  }

  render() {
    const {
      visibleItems,
      pageOffset,
      institutions,
      sectors,
    } = this.state;
    const { basePath, newItems } = this.props;
    const pageCount = Math.ceil(visibleItems.length / 21);
    const pager = pageCount > 1 ? (
      <Pager
        pages={pageCount}
        pageOffset={pageOffset}
        goToPage={this.goToPage}
      />
    ) : null;
    return (
      <div>
        <Filters institutions={institutions} sectors={sectors} applyFilters={this.applyFilters} />
        <List
          items={visibleItems}
          pageOffset={pageOffset}
          pageSize={21}
          basePath={basePath}
          newItems={newItems}
        />
        {pager}
      </div>
    );
  }
}

Dashboard.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  basePath: PropTypes.string.isRequired,
  newItems: PropTypes.arrayOf(PropTypes.string),
  fulltextFilter: PropTypes.func.isRequired,
};

Dashboard.defaultProps = {
  newItems: [],
};

export default Dashboard;
